import {useCallback, useContext, useEffect, useState} from "react";
import api from "services/api";
import AdminEstabelecimentoModal from './modal';
import config from 'config';
import {formatImage} from "components/formatos";
import {getadmin, getestabelecimentos} from "functions/gettabconfig";
import {CidadeContext} from "services/cidade";
import './style.css';
import PAGINACAO from "../../../components/paginacao";

function AdminEstabelecimento() {
    const [lEstabelecimento, setLEstabelecimento] = useState([]);
    const [idestabelecimento] = useState(getestabelecimentos(0));
    const [admin] = useState(getadmin());
    const [search, setSearch] = useState('');

    // Modal
    const [operacao, setOperacao] = useState('')
    const [dados, setDados] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [resetPage, setResetPage] = useState(false);

    const { cod_cidade } = useContext(CidadeContext)

    function closeAdminEstabelecimentoModal() {
        setIsOpen(false);
    }

    function novoCadastro() {
        const ldata = {
            'id_estabelecimento': 0,
            'nome': '',
            'url_foto': '',
            'url_logo': '',
            'avaliacao': 0,
            'id_categoria': 0,
            'id_cupom': null,
            'endereco': '',
            'complemento': '',
            'bairro': '',
            'cidade': '',
            'cep': '',
            'uf': '',
            'cod_cidade': cod_cidade,
            'ind_ativo': 'N',
            'qtd_avaliacao': 0,
            'vl_min_pedido': 0,
            'vl_taxa_entrega': 0,
            'telefone': '',
            'whatsup': ''
        }
        setDados(ldata);
        setIsOpen(true);
    }

    const searchEstabelecimento = useCallback(async () => {
        try {
            const response = await api.get(`${config.ADM_ESTABELECIMENTOS}?cod_cidade=${cod_cidade}`);
            const listaall = response.data;
            const lista = listaall.filter(f => {
                const matchNumeroId = f.id_estabelecimento.toString().includes(search);
                const matchNome = f.nome.toLowerCase().includes(search.toLowerCase());
                return matchNumeroId || matchNome;  // Considera correspondência em um ou outro campo
            });
            setLEstabelecimento(lista);
            setResetPage(true);
        } catch (error) {
            console.error("Erro ao buscar dados:", error);
        }
    }, [cod_cidade, search]);

    useEffect(() => {
        if (admin) {
            searchEstabelecimento();
        } else {
            api.get(`${config.ADM_ESTABELECIMENTOS}/${idestabelecimento}`)
                .then(response => {
                    setLEstabelecimento(response.data);
                })

        }

    }, [isOpen, cod_cidade, admin, idestabelecimento, searchEstabelecimento])

    useEffect(() => {
        if (resetPage) {
            setResetPage(false); // Reseta o estado após a redefinição da página
        }
    }, [resetPage]);

    function editarEstabelecimento(linha) {
        api.get(`${config.ADM_ESTABELECIMENTOS}/${linha.id_estabelecimento}`)
            .then(response => {
                setOperacao('UPDATE')
                setDados(response.data[0]);
                setIsOpen(true);
            }).catch(err => {
                console.log(err)
            })
    }
    function KeyDown(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            searchEstabelecimento();
        }
    }

    return (
        <div>
            <AdminEstabelecimentoModal 
                isOpen={isOpen}
                onRequestClose={closeAdminEstabelecimentoModal}
                operacao={operacao}
                dados={dados}
                habilitadelete={admin}
            />
            
            <div className="admin-header-section mb-4">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                    <h2 className="section-title mb-0">Gestão de Estabelecimentos</h2>
                    {admin && (
                        <button 
                            className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2" 
                            onClick={() => novoCadastro()}
                            style={{ borderRadius: '12px' }}
                        >
                            <i className="fas fa-plus"></i>
                            <span>Novo Estabelecimento</span>
                        </button>
                    )}
                </div>
                
                <div className="modern-search-bar mt-4 p-3 bg-card-admin rounded-4">
                    <div className="input-group">
                        <span className="input-group-text bg-transparent border-end-0 text-muted ps-3">
                            <i className="fas fa-search"></i>
                        </span>
                        <input 
                            type="search"
                            className="form-control border-start-0 ps-0 py-2 shadow-none"
                            placeholder="Pesquisar por nome ou ID..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            onKeyDown={KeyDown}
                        />
                        <button 
                            className="btn btn-primary px-4"
                            onClick={() => searchEstabelecimento()}
                            style={{ borderTopRightRadius: '10px', borderBottomRightRadius: '10px' }}
                        >
                            Pesquisar
                        </button>
                    </div>
                </div>
            </div>

            <PAGINACAO
                resetPage={resetPage}
                data={lEstabelecimento}
                itemsPerPage={12}
                renderItems={(currentItems) => (
                    <div className="row g-4">
                        {currentItems.map((e, index) => (
                            <div className="col-12 col-md-6 col-lg-4 col-xl-3" key={`est-${index}`}>
                                <div className="estabelecimento-card h-100 bg-card-admin rounded-4 overflow-hidden position-relative transition-all" onClick={() => editarEstabelecimento(e)}>
                                    <div className="p-3 border-bottom d-flex align-items-center justify-content-between bg-light-subtle">
                                        <span className="text-muted small fw-bold">ID: #{e.id_estabelecimento}</span>
                                        <div className={`status-dot ${e.ind_ativo === 'S' ? 'bg-success' : 'bg-danger'}`} title={e.ind_ativo === 'S' ? 'Ativo' : 'Inativo'}></div>
                                    </div>
                                    
                                    <div className="p-4 d-flex flex-column align-items-center text-center">
                                        <div className="estabelecimento-logo-wrapper mb-3 rounded-circle shadow-sm border">
                                            {formatImage(e.url_logo) ? (
                                                <img src={formatImage(e.url_logo)} alt={e.nome} className="rounded-circle" />
                                            ) : (
                                                <i className="fas fa-store fa-2x text-muted opacity-50"></i>
                                            )}
                                        </div>
                                        <h4 className="estabelecimento-name mb-2 text-truncate-2 w-100" title={e.nome}>
                                            {e.nome}
                                        </h4>
                                        <div className="text-muted small text-truncate w-100 mb-3">
                                            <i className="fas fa-map-marker-alt me-1 text-primary"></i>
                                            {e.endereco || 'Endereço não informado'}
                                        </div>
                                        
                                        <div className="mt-auto w-100 d-flex justify-content-center gap-2">
                                            {e.whatsup && <i className="fab fa-whatsapp text-success" title="WhatsApp disponível"></i>}
                                            {e.telefone && <i className="fas fa-phone text-primary" title="Telefone disponível"></i>}
                                        </div>
                                    </div>
                                    
                                    <div className="estabelecimento-actions p-3 border-top bg-light-subtle d-flex justify-content-center">
                                        <button className="btn btn-outline-primary btn-sm rounded-3 px-4 w-100">
                                            <i className="fas fa-edit me-1"></i> Gerenciar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            />
        </div>
    );
}

export default AdminEstabelecimento;